import * as R from "ramda";

const inlineJSONToHTMLStyleNames = {
  "bold": "b",
  "italic": "i",
  "underlined": "u",
  "strikethrough": "s",
  "subscript": "sub",
  "superscript": "sup",
  "link": "a",
} as const;

// TODO OTHER STYLES HERE
const tagTanslation = {
  "strong": "b",
  "em": "i",
} as const;

const inlineHTMLToJSONStyleNames = {
  "b": "bold",
  "strong": "bold",
  "i": "italic",
  "em": "italic",
  "u": "underlined",
  "s": "strikethrough",
  "sub": "subscript",
  "sup": "superscript",
  "a": "link",
} as const;

// TODO COMBINE SIMILAR STYLES <b>this </b><b>that</b>
// TODO: FIX????
export function inlineHTMLToJSON(inlineHTML: InlineHtmlContent, prefixInlineJSON: {text: string; styles: Array<StyleRange>, styleStarts: Partial<Record<StyleType, StyleStart>>}={text: "", styles: [], styleStarts: {}}, offset: number=0) {
  let {
    text,
    styles,
    styleStarts,
  } = prefixInlineJSON;

  const styleRegEx = /\<(\/)?([^<]+)>/g;
  const match = styleRegEx.exec(inlineHTML);

  if (match) {
    const beforeTagText = unescapeHtml(inlineHTML.slice(0, match.index));
    text = text + beforeTagText;

    const tagContents = R.trim(match[2]);

    const rawTagName = tagContents.split(/\s/)[0];

    const tagName = rawTagName in tagTanslation ? tagTanslation[rawTagName as (keyof typeof tagTanslation)] : rawTagName as StyleType;
    const isEndTag = !!match[1];

    // TODO: FIGURE OUT if tagName is StyleType

    if (isEndTag) {
      // TODO HANDLE IF NO styleStart
      const styleStart = styleStarts[tagName];
      if (styleStart) {
        const justStyle = R.dissoc("start", styleStart) as Style;

        styles = styles.concat([{
          ...justStyle,
          range: {
            start: styleStart.start,
            end: beforeTagText.length + offset,
          },
        }]);

        styleStarts = R.omit([tagName], styleStarts);
      }
    } else {
      const args = R.fromPairs([...tagContents.matchAll(/(\w+)="([^"]*)"/g)].map((m) => m.slice(1,3) as [string, string]));

      if (!styleStarts[tagName]) {
        styleStarts = {
          ...styleStarts,
          [tagName]: {
            type: tagName,
            args,
            start: beforeTagText.length + offset,
          },
        };
      }
    }

    const afterTagText = inlineHTML.slice(styleRegEx.lastIndex);

    return inlineHTMLToJSON(afterTagText, {
      text,
      styles,
      styleStarts,
    }, beforeTagText.length + offset);
  } else {
    return({
      text: text + unescapeHtml(inlineHTML),
      styles,
    });
  }
}

export function inlineJSONToHTML(inlineJSON: InlineJsonContent, extraEndTags=[]) {
  return internalInlineJSONToHTML(inlineJSON.text, R.sortBy((s) => s.range.start, inlineJSON.styles), R.sortBy((s) => s.range.end, inlineJSON.styles));
}

function internalInlineJSONToHTML(text: string, sortedStarts: Array<StyleRange>, sortedEnds: Array<StyleRange>, offset: number=0, startedStack: Array<StyleRange>=[]): string {
  const nextStartStyle = sortedStarts[0];
  const nextEndStyle = sortedEnds[0];

  if (nextEndStyle) {
    let offestTagSpot, tags;
    if (nextStartStyle && nextStartStyle.range.start < nextEndStyle.range.end) {
      tags = openHTMLTag(nextStartStyle);

      offestTagSpot = nextStartStyle.range.start - offset;

      sortedStarts = sortedStarts.slice(1);
      offset = nextStartStyle.range.start;
      startedStack = startedStack.concat([nextStartStyle]);
    } else {
      const [startedStackBase, startedStackTop] = R.splitWhen((s) => s.type === nextEndStyle.type, startedStack);
      const closeTags = R.reverse(startedStackTop).map((style) => closeHTMLTag(style)).join("");
      const openTags = R.tail(startedStackTop).map((style) => openHTMLTag(style)).join("");
      tags = closeTags + openTags;

      offestTagSpot = nextEndStyle.range.end - offset;

      sortedEnds = sortedEnds.slice(1);
      offset = nextEndStyle.range.end;
      startedStack = R.concat(startedStackBase, R.tail(startedStackTop));
    }

    const beforeTagText = escapeHtml(text.slice(0, offestTagSpot));
    const afterTagText = text.slice(offestTagSpot);

    return `${beforeTagText}${tags}${internalInlineJSONToHTML(afterTagText, sortedStarts, sortedEnds, offset, startedStack)}`;
  } else {
    return escapeHtml(text);
  }
}

function openHTMLTag(style: StyleRange) {
  const attributes = style.type == "a" ? R.toPairs(style.args).map(([argName, argValue]) => `${argName}="${argValue}"`).join(" ") : "";

  return `<${style.type} ${attributes}>`;
}

function closeHTMLTag(style: StyleRange) {
  return `</${style.type}>`;
}

function escapeHtml(text: string) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")
    .replace(/\s\s/g, " &nbsp;")
    .replace(/\s$/g, "&nbsp;")
    .replace(/^\s/g, "&nbsp;");
}

function unescapeHtml(html: InlineHtmlContent) {
  return html
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, "\"")
    .replace(/&#039;/g, "'")
    .replace(/&nbsp;/g, " ");
}
